import { useState } from 'react'
import Column from '@app/components/layout/Column'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { Tag } from '@app/components/core/tag/Tag'
import { SelectableTagModel } from '@app/types/TagModel'
import { useTranslations } from '@i18n/useLanguage'
import { Button } from '@app/components/core/button/Button'
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'

export type TagSelectionProps<TKey extends string | number> = {
  label: string
  subTitle: string
  tags: SelectableTagModel<TKey>[]
  collapsedAmountVisible?: number
  onSelect: (id: TKey) => void
}

export const TagSelection = <TKey extends string | number>({
  label,
  subTitle,
  tags,
  collapsedAmountVisible = 5,
  onSelect,
}: TagSelectionProps<TKey>) => {
  const translations = useTranslations().app.common
  const [exapnded, setExpanded] = useState(false)
  const hasMore = tags.length > collapsedAmountVisible
  const shownTags = exapnded ? tags : tags.slice(0, collapsedAmountVisible)

  return (
    <Column gap={'0.5rem'}>
      <Column gap={0}>
        <Text.Medium isBold={true}>{label}</Text.Medium>
        <Text.Small color={'var(--palette-blue-400)'}>{subTitle}</Text.Small>
      </Column>
      <Row
        style={{
          flexWrap: 'wrap',
          gap: '0.5rem',
        }}
      >
        {shownTags.map((tag) => (
          <Tag
            key={tag.key}
            label={tag.value}
            variant={tag.selected ? 'subtle' : 'transparent'}
            size="small"
            onClick={() => onSelect(tag.key)}
          />
        ))}
        {hasMore && (
          <Button
            variant="link"
            label={exapnded ? translations.less : translations.more}
            iconPosition="left"
            icon={exapnded ? faMinus : faPlus}
            onClick={() => setExpanded((prev) => !prev)}
          />
        )}
      </Row>
    </Column>
  )
}
